<template>
    <div>
        <div class="lke-bg">
            <div class="lke-bg-in">
                <div class="lke-l">
                    <div class="lke-l-top">
                        <div class="lke-l-top-l"></div>
                        考试专栏
                    </div>
                    <div class="lke-l-mid">
                        <div class="lke-l-mid-tab" :class="{ active: index == tabIndex }" v-for="(tab,index) in tabs" :key="index" @click="changTab(tab.rou,index)">{{tab.name}}</div>
                    </div>
                    <div class="lke-l-fot">
                        <div class="lke-l-fot-top">
                            <p><span>当前状态：</span></p>
                            <p><span>当前状态：</span>未完成</p>
                            <p class="lke-l-fot-top-last">说明：学习进度要求达到0%以上</p>
                        </div>
                        <div class="lke-l-fot-fot">
                            开始考试
                        </div>
                    </div>
                </div>
                <div class="lke-r">
                    <div class="lke-l-top r">
                        <div class="lke-l-top-l r"></div>
                        考试专栏
                    </div>
                    <router-view style="padding:40px"/>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: {

    },
    data() {
        return {
            tabIndex: 0,
            tabs: [
                {name: '个人信息', rou: 'khjyIndex' },
                {name: '考试说明', rou: 'khjyIndex' },
                {name: '模拟考试', rou: 'khjyIndex' },
                {name: '试题下载', rou: 'khjyIndex' },
                {name: '辅导答疑', rou: 'khjyIndex' },
                {name: '成绩查询', rou: 'khjyIndex' },
            ],

        };
    },
    computed: {

    },
    created() {

    },
    mounted() {

    },
    watch: {

    },
    methods: {

        changTab(tab,index) {
            this.tabIndex = index;
            this.$router.push({ name: tab });
        },

    },
    components: {

    },
};
</script>

<style>

</style>

<style scoped>
.lke-bg{
    display: flex;
    justify-content: center;
}
.lke-bg-in{
    width: 964px;
    margin: 20px;
    display: flex;
    border: 1px solid #ccc;
}
.lke-l{
    background: #EDEFF4;
    border-right: 1px solid #ccc;
    padding: 4px 0 4px 4px;
    width: calc(30%);
}
.lke-l-top{
    background: #3B5997;
    display: flex;
    padding: 8px 0 8px 20px;
    font-size: 18px;
    color: #fff;
    font-family: "\5FAE\8F6F\96C5\9ED1";
}
.lke-l-top.r{
    background: #EDEFF4;
    color: #3B5997;
}
.lke-l-top-l{
    background: #fff;
    width: 4px;
    margin-right: 20px;
}
.lke-l-top-l.r{
    background: #3B5997;
}
.lke-l-mid{
    padding-top: 40px;
    padding-bottom: 20px;
    display: flex;
    justify-content: space-around;
    flex-wrap: wrap;
}
.lke-l-mid-tab{
    width: calc(35%);
    padding: 8px;
    margin-bottom: 20px;
    background: #005AA8;
    color: #fff;
    font-size: 15px;
    font-family: "\5FAE\8F6F\96C5\9ED1";
    text-align: center;
    border-radius: 10px;
    cursor: pointer;
    letter-spacing: 1px;
    box-shadow: inset 0 0 5px 3px rgba(0, 0, 0, .2)
}
.lke-l-mid-tab.active{
    background: #77AF56;
}
.lke-l-fot-top{
    padding: 18px;
    border: 1px solid #ccc;
    background: #F2F2F2;
    margin: 0 20px;
}
.lke-l-fot-top > p{
    font-size: 14px;
    line-height: 1.8;
    color: #FF0000;
}
.lke-l-fot-top > p > span{
    color: #333;
    font-weight: bold;
}
.lke-l-fot-top-last{
    color: #333 !important;
    font-size: 12px;
}
.lke-l-fot-fot{
    background: url('http://lnsgsjnrz.eswonline.com/learning/resbase/sites/thtylnsg/student/default/public/exam/images/start_exam_btn.png')  center 0 no-repeat;
    width: 160px;
    height: 50px;
    color: #fff;
    font-size: 18px;
    font-family: "\5FAE\8F6F\96C5\9ED1";
    padding: 0 0 0 80px;
    cursor: pointer;
    letter-spacing: 20px;
    line-height: 50px;
    margin: 40px auto;
}
.lke-r{
    flex: 1;
    padding: 4px 0;
    background: #FFFFFF;
}
</style>



// WEBPACK FOOTER //
// src/pages/index/page/khjy/khjy.vue